import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdminRoute } from '../components';
import {AdminLayout, UserLayout} from '../Layout';
import {
  Home,
  Login,
  Register,
  DashboardShirt,
  ShirtForm,
  DashboardTrouser,
  TrouserForm,
  DashboardJacket,
  JacketForm,
  DashboardUser,
  Shirt,
  Trouser,
  Jacket,
  About,
  Dashboard,
  DetailShirt,
  DetailTrouser,
  DashboardSlider,
  SliderForm,
} from '../pages';
import DetailJacket from '../pages/Detail/DetailJacket';

const Routers = () => {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route path={'/'} element={<UserLayout content={<Home />} />} />
          <Route path={'/shirt'} element={<UserLayout content={<Shirt />} />} />
          <Route
            path={'/trouser'}
            element={<UserLayout content={<Trouser />} />}
          />
          <Route
            path={'/jacket'}
            element={<UserLayout content={<Jacket />} />}
          />
          <Route path={'/about'} element={<UserLayout content={<About />} />} />
          <Route
            path={'/shirt/detail/:Id'}
            element={<UserLayout content={<DetailShirt />} />}
          />
          <Route
            path={'/trouser/detail/:Id'}
            element={<UserLayout content={<DetailTrouser />} />}
          />
          <Route
            path={'/jacket/detail/:Id'}
            element={<UserLayout content={<DetailJacket />} />}
          />

          {/* Auth */}
          <Route path={'/login'} element={<Login />} />
          {/* <Route path={'/register'} element={<Register />} /> */}

          {/* Admin */}
          <Route element={<AdminRoute />}>
            <Route
              path={'/dashboard'}
              element={<AdminLayout content={<Dashboard />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'/dashboard/shirt/'}
              element={<AdminLayout content={<DashboardShirt />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'/dashboard/shirt/create'}
              element={<AdminLayout content={<ShirtForm />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={`/dashboard/shirt/edit/:idShirt`}
              element={<AdminLayout content={<ShirtForm />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'/dashboard/trouser/'}
              element={<AdminLayout content={<DashboardTrouser />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'/dashboard/trouser/create'}
              element={<AdminLayout content={<TrouserForm />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'/dashboard/trouser/edit/:Id'}
              element={<AdminLayout content={<TrouserForm />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'/dashboard/jacket'}
              element={<AdminLayout content={<DashboardJacket />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'/dashboard/jacket/create'}
              element={<AdminLayout content={<JacketForm />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'/dashboard/jacket/edit/:Id'}
              element={<AdminLayout content={<JacketForm />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'dashboard/user'}
              element={<AdminLayout content={<DashboardUser />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'dashboard/slider'}
              element={<AdminLayout content={<DashboardSlider />} />}
            />
          </Route>
          <Route element={<AdminRoute />}>
            <Route
              path={'dashboard/slider/create'}
              element={<AdminLayout content={<SliderForm />} />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
};

export default Routers;
